import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  useMediaQuery,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import EmpAdminModal from "./EmpAdminModal";
import FuseLoading from "@fuse/core/FuseLoading";
import { useDispatch, useSelector } from "react-redux";
import { useDeepCompareEffect } from "@fuse/hooks";
import { getEmpAdmins, selectEmpAdmin } from "../store/empAdminSlice";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${TableCell.head}`]: {
    backgroundColor: "#ffffff",
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  [`&.${TableCell.body}`]: {
    fontSize: 14,
  },
}));

export default function EmpAdminTable() {
  const dispatch = useDispatch();
  const empAdmins = useSelector(selectEmpAdmin);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useDeepCompareEffect(() => {
    dispatch(getEmpAdmins());
  }, [dispatch]);

  if (!empAdmins) {
    return <FuseLoading />;
  }

  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
        <Table
          sx={{ minWidth: isMobile ? 350 : 650 }}
          aria-label="tabla administradores"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Nombre</StyledTableCell>
              <StyledTableCell align="right">Acciones</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {empAdmins.map((empAdmin) => (
              <TableRow
                key={empAdmin.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { backgroundColor: theme.palette.action.hover },
                }}
              >
                <TableCell component="th" scope="row">
                  {empAdmin.name}
                </TableCell>
                <TableCell align="right">
                  <EmpAdminModal isEdit={true} empAdmin={empAdmin} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
